import { LeadEmailFormInputInterface } from 'common/module/lead/email/form/input.interface';

import { AgentLeadModel } from './model';

export class AgentLeadModelAdapter {
  /**
   * Create model from lead email form
   */
  public createModelFromLeadEmailForm(data: LeadEmailFormInputInterface): AgentLeadModel {
    const model = new AgentLeadModel();

    model.name = data.name.value;
    model.email = data.email.value;
    model.message = data.message.value;
    model.phone = data.phone.value;
    model.enquiry_type = data.enquiryType.value;

    if (data.acceptTerms) {
      model.acceptTerms = data.acceptTerms.value;
    }

    if (data.receiveAdvertising) {
      model.receiveAdvertising = data.receiveAdvertising.value;
    }

    if (data.captcha.value) {
      model.captcha_token = data.captcha.value;
    }

    return model;
  }
}
